"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleVersion = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
var TitleVersion;
(function (TitleVersion) {
    TitleVersion["Clickbait"] = "clickBait";
    TitleVersion["Long"] = "long";
    TitleVersion["Short"] = "short";
    TitleVersion["TeaserBox"] = "teaserBox";
})(TitleVersion = exports.TitleVersion || (exports.TitleVersion = {}));
//# sourceMappingURL=title.js.map